export default "__VITE_ASSET__ade56e8f__"